// Shared smooth-scroll helper that works with the Lenis instance.
let lenisInstance = null;

export const setLenis = (l) => {
  lenisInstance = l;
};

export const scrollToId = (selector) => {
  const el = typeof selector === "string" ? document.querySelector(selector) : selector;
  if (!el) return;
  if (lenisInstance) {
    lenisInstance.scrollTo(el, { offset: -72, duration: 1.3 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToTop = () => {
  if (lenisInstance) lenisInstance.scrollTo(0, { duration: 1.3 });
  else window.scrollTo({ top: 0, behavior: "smooth" });
};
